import authClient from './client';

const authSystem = new authClient(window.AuthJs || {})

// Trigger initialization when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    authSystem.emit('auth:init');
  });
} else {
  // DOM already loaded
  authSystem.emit('auth:init');
}


